import type { LightboxState, LightboxElements } from './types';
import { updateImageTransform } from './zoom';

export function constrainPan(state: LightboxState, elements: LightboxElements): void {
    const contentRect = elements.content.getBoundingClientRect();
    const scaledWidth = elements.img.naturalWidth * state.zoomLevel;
    const scaledHeight = elements.img.naturalHeight * state.zoomLevel;

    const maxX = Math.max(0, (scaledWidth - contentRect.width) / 2);
    const maxY = Math.max(0, (scaledHeight - contentRect.height) / 2);

    state.translateX = Math.max(-maxX, Math.min(maxX, state.translateX));
    state.translateY = Math.max(-maxY, Math.min(maxY, state.translateY));
}

export function getPinchDistance(touches: TouchList): number {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
}

export function handleTouchStart(state: LightboxState, elements: LightboxElements, e: TouchEvent): void {
    if (e.touches.length === 2) {
        e.preventDefault();
        state.initialPinchDistance = getPinchDistance(e.touches);
        state.initialZoom = state.zoomLevel;
    } else if (e.touches.length === 1 && state.zoomLevel > 1) {
        state.isDragging = true;
        state.touchStartX = e.touches[0].clientX - state.lastTranslateX;
        state.touchStartY = e.touches[0].clientY - state.lastTranslateY;
        elements.img.classList.add('is-dragging');
    }
}

export function handleTouchMove(
    state: LightboxState,
    elements: LightboxElements,
    e: TouchEvent,
    setZoom: (level: number) => void
): void {
    if (e.touches.length === 2) {
        e.preventDefault();
        const currentDistance = getPinchDistance(e.touches);
        const scale = currentDistance / state.initialPinchDistance;
        setZoom(state.initialZoom * scale);
    } else if (e.touches.length === 1 && state.isDragging) {
        e.preventDefault();
        state.translateX = e.touches[0].clientX - state.touchStartX;
        state.translateY = e.touches[0].clientY - state.touchStartY;
        constrainPan(state, elements);
        updateImageTransform(state, elements);
    }
}

export function handleTouchEnd(state: LightboxState, elements: LightboxElements, e: TouchEvent): void {
    if (e.touches.length === 0 && state.isDragging) {
        state.isDragging = false;
        state.lastTranslateX = state.translateX;
        state.lastTranslateY = state.translateY;
        elements.img.classList.remove('is-dragging');
    }
    state.initialPinchDistance = 0;
}
